export enum ProjectStatus {
    CREATED = "CREATED",
    OK = "OK",
    FAILED = "FAILED",
    MIGRATING = "MIGRATING"
}